module.exports = require("echarts-for-react");